import './MobileViewCashinClosingModeActive.less';
import CashinClosingModeEditor from 'nike-ui/src/components/ticketus/cashin/CashinClosingModeEditor';
import Immutable, { fromJS } from 'immutable';
import PopupNg from '@/ui/PopupNg';
import React, { FC, useEffect, useState } from 'react';
import useLocalStorage from 'nike-ui/src/common/hooks/useLocalStorage';
import { CashinPosition } from 'nike-ui/src/components/turboLive/components/cashin/constants';
import { CustomerChangeApproval } from 'nike-ui/src/components/ticketus/constants';
import {
    allPicksChosen$,
    cashinClosingChosenDisabledPicks$,
    evalEventualTotalsWin$
} from 'nike-ui/src/components/ticketus/subs';
import { cashinOfferByTicketId$$ } from 'nike-ui/src/components/turboLive/components/cashin/subs';
import { clearCashinClosingMode } from 'nike-ui/src/components/ticketus/handlers';
import { closeCashinTicket } from '@/cashins/handlers';
import { dispatch, useReframe } from 'nike-re-framejs';
import { fireGAEvent } from '@/analytics';
import { ticketCashinTicketId$ } from '@/cashins/subs';
import { trackDwhCashinEvent } from 'nike-ui/src/components/dwh-tracking/api';
import { useCashinClosing } from 'nike-ui/src/components/ticketus/cashin/useCashinHooks';
import { useIsCashinDisabled } from 'nike-ui/src/components/ticketus/cashin/useIsCashinDisabled';
import { useSwipeable } from 'react-swipeable';

const SWIPEABLE_CONFIG = {
    preventScrollOnSwipe: true
};

/**
 Component na Uzatvaranie Tiketu pre Mobil
 handluje scrollEvent na stranke, click event na wrapper componentu a swipe event
 Na zaklade tychto eventov sa posiela minimalized parameter do child elementu
 **/
const MobileViewCashinClosingModeActive: FC<void> = () => {
    const [minimalizedEditor, setMinimalizedEditor] = useState(false);
    const [currentOffsetY, setCurrentOffsetY] = useState(0);
    const [checkBoxValue, setCheckboxValue] = useLocalStorage(
        'defaultCashinClosingCheckbox',
        CustomerChangeApproval.ALL
    );
    const [hideCheckboxes, setHideCheckboxes] = useState(true);
    const [eventualWin, setEventualWin] = useState(0);

    const minScrollDistance = 5;
    const { subscribe } = useReframe();
    const ticketId = subscribe(ticketCashinTicketId$);
    const newEventualWin = subscribe(evalEventualTotalsWin$(ticketId));
    const allPicksChosen = subscribe(allPicksChosen$(ticketId));
    const chosenDisabledPicks = subscribe(cashinClosingChosenDisabledPicks$(ticketId));
    const currentTicket = subscribe(cashinOfferByTicketId$$(ticketId));
    const isCashinDisabled = useIsCashinDisabled(fromJS(currentTicket));
    const { isCashinClosingDisabled, cashinClosingBetIds } = useCashinClosing(ticketId, isCashinDisabled);

    const swipeHandlers = useSwipeable({
        onSwipedUp: () => maximalizeEditor(),
        onSwipedDown: () => setMinimalizedEditor(true),
        ...SWIPEABLE_CONFIG
    });

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    });

    useEffect(() => {
        if (cashinClosingBetIds && cashinClosingBetIds.length > 0) {
            if (newEventualWin) {
                setEventualWin(newEventualWin);
            } else {
                setEventualWin(0);
            }
        } else {
            setEventualWin(0);
        }
    }, [cashinClosingBetIds, newEventualWin]);

    const handleScroll = (): void => {
        if (!minimalizedEditor) {
            if (window.scrollY - currentOffsetY > minScrollDistance) {
                setMinimalizedEditor(true);
                setHideCheckboxes(true);
            }
        }
        setCurrentOffsetY(window.scrollY);
    };

    const maximalizeEditor = (): void => {
        if (minimalizedEditor) {
            setMinimalizedEditor(false);
        }
    };

    const onCheckboxChange = (value: string): void => {
        setCheckboxValue(value);
        setHideCheckboxes(true);
    };

    const onCancelButtonChange = (): void => {
        dispatch(clearCashinClosingMode);
    };

    const onSubmitButtonChange = (): void => {
        dispatch(closeCashinTicket(checkBoxValue, newEventualWin, currentTicket));
    };

    const toggleHideCheckboxes = (): void => {
        setHideCheckboxes(!hideCheckboxes);
    };

    const onCashinButtonClick = () => () => {
        fireGAEvent('Odkup tiketu', 'Predaj podaneho tiketu');
        trackDwhCashinEvent('manual_cashin', ticketId, currentTicket?.betType, 'TICKET_DETAIL');
        dispatch([
            'ticketus/cashin-transaction/start',
            currentTicket.ticketId,
            currentTicket.amount,
            checkBoxValue === CustomerChangeApproval.ALL,
            currentTicket.version,
            CashinPosition.TICKET_DETAIL
        ]);
        PopupNg.dispatcher.open('ticketus/cashin-dialog', Immutable.fromJS({ ticketId, showConfirmDialog: false }));
    };

    return (
        <div
            {...swipeHandlers}
            className="p-fix full-width ticket-closing-editor-wrapper"
            onClick={maximalizeEditor}
            onDoubleClick={maximalizeEditor}
        >
            {currentTicket ? (
                <CashinClosingModeEditor
                    amount={currentTicket.amount}
                    allPicksChosen={allPicksChosen}
                    currentEventualWin={currentTicket.win}
                    checkboxValue={checkBoxValue}
                    hideCheckboxes={hideCheckboxes}
                    isCashinButtonDisabled={isCashinClosingDisabled}
                    newEventualWin={eventualWin}
                    minimalizedEditor={minimalizedEditor}
                    onCheckboxChange={onCheckboxChange}
                    onCancelButtonClick={onCancelButtonChange}
                    onSubmitButtonClick={onSubmitButtonChange}
                    onCashinButtonClick={onCashinButtonClick}
                    selectedCashinsCount={cashinClosingBetIds?.length || 0}
                    selectedDisabledCount={chosenDisabledPicks.length}
                    toggleHideCheckboxes={toggleHideCheckboxes}
                    portal={false}
                    ticketId={ticketId}
                />
            ) : null}
        </div>
    );
};

export default MobileViewCashinClosingModeActive;
